<!-- Main Container Wrapper -->
<div class="transition-base">

  <!-- Main Grid Dashboard Card Container -->
  <div class="card border shadow-sm rounded-4 overflow-hidden h-100 d-flex flex-column transition-base bg-body">

    <!-- Dashboard Card Header Panel -->
    <div class="card-header border-bottom py-3 px-4 transition-base bg-transparent">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">

        <!-- Title Metadata Header Info -->
        <div>
          <h5 class="mb-1 fw-bold tracking-wide d-inline-flex align-items-center gap-2 text-body">
            <i class="fa-solid fa-user-shield text-danger"></i>Block Phone Management
          </h5>
          <p class="text-body-secondary font-xs mb-0">
            Manage blocked digital wallet transaction endpoints and phone bill accounts
          </p>
        </div>

        <!-- Segmented Filter Switch Radio Buttons Group -->
        <div class="btn-group btn-group-sm p-1 rounded-pill border shadow-sm transition-base bg-body-tertiary"
          role="group">

          <input type="radio" class="btn-check" name="btnradio" id="btnradiokbz" [value]="providerTypes.KBZ"
            (change)="onRadioChange($event)" checked>
          <label
            class="btn btn-outline-primary rounded-pill border-0 px-3 fw-bold font-monospace font-xs text-uppercase"
            for="btnradiokbz">KBZ</label>

          <input type="radio" class="btn-check" name="btnradio" id="btnradiowave" [value]="providerTypes.WAVE"
            (change)="onRadioChange($event)">
          <label
            class="btn btn-outline-primary rounded-pill border-0 px-3 fw-bold font-monospace font-xs text-uppercase"
            for="btnradiowave">Wave</label>

          <input type="radio" class="btn-check" name="btnradio" id="btnradioaya" [value]="providerTypes.AYA"
            (change)="onRadioChange($event)">
          <label
            class="btn btn-outline-primary rounded-pill border-0 px-3 fw-bold font-monospace font-xs text-uppercase"
            for="btnradioaya">AYA</label>

          <input type="radio" class="btn-check" name="btnradio" id="btnradiophonebill"
            [value]="providerTypes.Phone_Bill" (change)="onRadioChange($event)">
          <label
            class="btn btn-outline-primary rounded-pill border-0 px-3 fw-bold font-monospace font-xs text-uppercase"
            for="btnradiophonebill">Phone Bill</label>
        </div>

      </div>
    </div>

    <!-- Responsive Action Table Block -->
    <div class="card-body p-0">
      <div class="table-responsive m-0">
        <table class="table table-hover align-middle mb-0 transition-base text-nowrap table-dense">

          <!-- Table Header Matrix -->
          <thead
            class="table-light border-bottom font-monospace small text-uppercase text-nowrap tracking-wider text-body-secondary">
            <tr>
              <th scope="col" class="ps-4" width="70">No</th>
              @if (type !== providerTypes.Phone_Bill) {
              <th scope="col" style="min-width: 150px;">Payment Phone</th>
              <th scope="col" style="min-width: 160px;">Payment Name</th>
              }
              @if (type === providerTypes.Phone_Bill) {
              <th scope="col" style="min-width: 150px;">Phone Bill</th>
              }
              <th scope="col">Login Phone</th>
              <th scope="col">Reason</th>
              <th scope="col" class="text-center" width="120">Status</th>
              <th scope="col" class="pe-4 text-end" width="120">Action</th>
            </tr>
          </thead>

          <!-- Table Row Content Loop -->
          <tbody class="small text-body">
            @for (data of results() | paginate : { itemsPerPage: pageSize(), currentPage: page(), totalItems: allTotal()
            }; track data.srNo; let i = $index) {
            <tr class="transition-base">

              <!-- Serial Row Position -->
              <td class="ps-4 font-monospace fw-semibold text-body-secondary">
                {{ data.srNo }}
              </td>

              <!-- Conditional Layout Parameters -->
              @if (type !== providerTypes.Phone_Bill) {
              <td class="fw-bold font-monospace text-body">{{ data.paymentPhone }}</td>
              <td class="fw-medium text-body">{{ data.paymentName }}</td>
              }
              @if (type === providerTypes.Phone_Bill) {
              <td class="fw-bold font-monospace text-body">{{ data.billTopUPhone }}</td>
              }

              <td class="font-monospace text-body-secondary">{{ data.loginPhone }}</td>
              <td>
                <span class="text-body-secondary d-inline-block text-truncate max-w-220" [title]="data.reason">
                  {{ data.reason || 'No reason provided' }}
                </span>
              </td>

              <!-- Status Badge Elements -->
              <td class="text-center">
                @if (data.isBlock === 'TRUE') {
                <span
                  class="badge bg-danger-subtle text-danger-emphasis border border-danger-subtle px-2.5 py-1.5 rounded-pill">
                  <i class="fa-solid fa-circle-xmark"></i> Blocked
                </span>
                } @else {
                <span
                  class="badge bg-success-subtle text-success-emphasis border border-success-subtle px-2.5 py-1.5 rounded-pill">
                  <i class="fa-solid fa-circle-check"></i> Active
                </span>
                }
              </td>

              <!-- Table Quick Interaction Button Action (Icon Center + Loading Spinner Fix) -->
              <td class="pe-4 text-end">
                @if (data.isBlock === 'TRUE') {
                <button type="button"
                  class="btn btn-sm btn-icon btn-success rounded-circle shadow-sm transition-base d-inline-flex align-items-center justify-content-center"
                  title="Unblock user" [disabled]="isUnBlockBtnLoading()[i]" (click)="unBlockPhone(data, i)">
                  @if (isUnBlockBtnLoading()[i]) {
                  <span class="spinner-border micro-spinner m-0" role="status" aria-hidden="true"></span>
                  } @else {
                  <i class="fa-solid fa-lock-open font-xs"></i>
                  }
                </button>
                } @else {
                <span class="text-body-secondary small fst-italic pe-2 opacity-50">-</span>
                }
              </td>
            </tr>
            } @empty {
            <!-- Empty Data Fallback Operational Placeholder -->
            <tr>
              <td [attr.colspan]="type === providerTypes.Phone_Bill ? 5 : 7"
                class="text-center py-5 text-body-secondary">
                <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center">
                  <i class="fa-regular fa-folder-open display-6 mb-3 opacity-50"></i>
                  <span class="tracking-wider">No blocked phone records found.</span>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <!-- Navigation Pagination Footer -->
    <div
      class="card-footer bg-transparent border-top py-3 px-4 transition-base d-flex flex-column flex-sm-row align-items-center justify-content-center">
      <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
        class="dashboard-pagination" (pageChange)="handlePageChange($event)">
      </pagination-controls>
    </div>

  </div>
</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px)">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">Loading...</div>
</div>
}